import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { LicenseSubFormComponent } from '../../types/LicenseSubFormComponent';
import { LicenseBasicMonthlySubscriptionSubFormController } from '../controller/LicenseBasicMonthlySubscriptionSubFormController';
import { CompanyType } from '../../../company/types/company-type';
import { LicenseMainFormViewData } from '../../licenseMainForm/types/LicenseMainFormViewData';
import { Observable } from 'rxjs';
import { FormGroupValue } from '../../../ui/gzForm/formGroup/types/form-group-value';
import { CompanyData } from '../../../company/types/company-data';
import { DeepPartial } from 'typeorm';

export class LicenseBasicMonthlySubscriptionSubFormWebComponent
  extends BaseWebComponentElement
  implements LicenseSubFormComponent
{
  public controller!: LicenseBasicMonthlySubscriptionSubFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: LicenseBasicMonthlySubscriptionSubFormController,
    });
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get value(): FormGroupValue {
    return this.controller.view.getFormValue();
  }

  public updateDefaultProductDelegateFeature(companyType: CompanyType) {
    this.controller.view.updateDefaultProductDelegateFeature(companyType);
  }

  public setViewData(viewData: LicenseMainFormViewData) {
    this.controller.view.setViewData(viewData);
  }

  public setSubscriptionDetails(company: DeepPartial<CompanyData>) {
    this.controller.view.setSubscriptionDetails(company);
  }

  public setCompanyData(company: CompanyData): void {
    this.controller.setCompanyData(company);
  }
}
